import * as types from './constants';

// Get Creator Signals
export const getCreatorSignalsRequest = data => (
  { type: types.GET_CREATOR_SIGNALS_REQUEST, payload: data }
);

export const getCreatorSignalsDone = data => (
  { type: types.GET_CREATOR_SIGNALS_DONE, payload: data }
);

export const getCreatorSignalsFailed = (errors, error) => (
  {
    type: types.GET_CREATOR_SIGNALS_FAILED,
    payload: {
      errors_api: errors || {},
      status: error?.response?.status || null
    }
  }
);

export const getCreatorSignalsReset = () => (
  { type: types.GET_CREATOR_SIGNALS_RESET }
);
